<template>
  <div class="bg-white container" style="padding: 16px 16px 0px">
    <record :list="info.list" :userStatus="info.status"></record>
    <!-- 判责 -->
    <div class="margin-top-20" v-if="info.status === 'duty_in'">
      <div class="text-bold">恶意追责将被平台封禁</div>
      <div class="text-12 text-grey1 margin-tb-8">平台介入只为初步核实，如你“恶意追责”对方，除扣除已追责的金额外，平台有权对您进行封禁</div>
      <div class="margin-tb-16 flex align-center" >
        <img src="@/assets/images/kf/checked.png" width="15px">
        <div class="text-grey margin-left-4">我已了解平台规则，申请平台介入审核</div>
      </div>
      <div class="margin-top-20">
        <van-button block type="primary" class="margin-bottom-16" :loading="loading" @click="confirmDuty">我要追责赔偿</van-button>
      </div>
    </div>

    <!-- 追责弹框 -->
    <van-popup v-model="show" position="bottom">
      <div class="flex flex-y align-center padding-20">
        <img src="@/assets/images/kf/duty.png" width="113px" alt="">
        <div class="text-20 text-bold margin-tb-16">追责已发出</div>
        <div>您可以在客服中心-服务进度中查看相关进度</div>
        <div class="width-full margin-top-16">
          <van-button block @click="show = false">好的，等消息</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { Popup } from 'vant'

import { fetchWorkOrder, confirmDuty } from 'api/service'
import { wordOrder } from '@/utils/constant'

import record from './components/record'

Vue.use(Popup)
export default {
  components: {
    record
  },
  data ({ $route }) {
    return {
      wordOrder,
      id: $route.params.id,
      info: {
        recordList: [],
        status: ''
      },
      show: false,
      loading: false
    }
  },
  created () {
    this.fetchWorkOrder()
  },
  computed: {
  },
  methods: {
    async fetchWorkOrder () {
      this.info = await fetchWorkOrder({
        orderId: this.id
      })
    },
    async confirmDuty () {
      this.loading = true
      try {
        await confirmDuty({
          orderId: this.id,
          userType: this.info.list[0].sender,
          dutyResult: 1
        })
        this.show = true
        this.fetchWorkOrder()
      } catch (error) {} finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
}

.ball {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

// .footer {
//   position: fixed;
//   width: 100%;
//   left: 0;
//   bottom: 0;
// }
</style>
